module.exports = __webpack_public_path__ + "static/media/close_circle.77cbf969.svg";